import React from "react";

import {
  Box,
  Flex,
  Text,
  Image,
  Center,
  Link,
  Icon,
  IconButton
} from "@chakra-ui/react";

import { Link as NavLink } from "react-router-dom";

import {
  AiFillFacebook,
  AiFillTwitterCircle,
  AiFillInstagram,
  AiFillMail
} from "react-icons/ai";

export default function Footer() {
  return (
    <Flex flexDirection="column" margin={4} marginTop={24} alignItems="center">
      <center>
        <a href="/">
          {/* <Image
            className="Image"
            htmlWidth={150}
            src="https://res.cloudinary.com/drswuejor/image/upload/v1631541151/Astroworkers_1_aspsnt.png"
          /> */}
          <Text mb={3} fontSize={24} fontWeight="bold">
            Astroworkers
          </Text>
        </a>
      </center>
      <Text paddingTop={3}>
        <Link as={NavLink} to="/about">
          About
        </Link>
      </Text>
      <Text paddingTop={3}>
        <Link as={NavLink} to="/about">
          Wall of Frame
        </Link>
      </Text>
      <Text paddingTop={3}>
        <Link as={NavLink} to="/affiliate-program">
          Affiliate Program
        </Link>
      </Text>
      <Text paddingTop={3}>
        <Link as={NavLink} to="/workers-making-money-online">
          Freelance & Earn
        </Link>
      </Text>
      <Text paddingTop={3}>
        <Link as={NavLink} to="/terms">
          Terms of Use
        </Link>
      </Text>
      <Text paddingTop={3}>
        <Link as={NavLink} to="/privacy">
          Privacy Policy
        </Link>
      </Text>
      <Text color="grey" marginTop={14}>
        © 2021 Astroworkers.com. All Rights Reserved.
      </Text>
      <Flex marginTop={3}>
        <IconButton
          aria-label="Facebook icon"
          icon={<Icon as={AiFillFacebook} />}
        />
        <IconButton
          marginLeft={2}
          aria-label="Twitter icon"
          icon={<Icon as={AiFillTwitterCircle} />}
        />
        <IconButton
          marginLeft={2}
          aria-label="Instagram icon"
          icon={<Icon as={AiFillInstagram} />}
        />
        <IconButton
          marginLeft={2}
          aria-label="Email icon"
          icon={<Icon as={AiFillMail} />}
        />
      </Flex>
    </Flex>
  );
}
